import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CmsTokenBridgeService } from './cms-token-bridge.service';
export const cmsAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const bridge = inject(CmsTokenBridgeService);
  const token = bridge.getToken();
  if (!token) {
    return next(req);
  }
  const payload = bridge.ssoPayload();
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`
  };
  // For federated sessions, send the canonical Cognito ID so the CMS backend
  // can resolve the user without depending on the token's sub claim.
  if (payload?.user?.isFederated && payload.user.cognitoId) {
    headers['X-Cognito-Id'] = payload.user.cognitoId;
  }
  if (payload?.user?.email) {
    headers['X-User-Email'] = payload.user.email;
  }
  const authReq = req.clone({ setHeaders: headers });
  return next(authReq);
};
